import { getNetworkName } from '@/utils/network/getNetworkName'
import { getNetworkImage } from '@vaultsfyi/common/utils'
import { RoundImage } from './roundImage'

interface NetworkImageProps {
  network: string
  className?: string
}

export const NetworkImage = ({ network, className }: NetworkImageProps) => {
  return (
    <RoundImage
      src={getNetworkImage(network)}
      fallback={getNetworkImage('fallback')}
      alt={getNetworkName(network)}
      className={className}
    />
  )
}
